export function intlHeaderTexts(intlModel) {
    if (!intlModel) return () => '';
    return (accessor) => intlModel[accessor]();
}
